import React from "react";
import "../ViewInvoice.css";
import ErrorPopup from "../../../../components/element/ErrorPopup";
import Loader from "../../../../components/element/Loader";
import NoDataPlaceholder from "../../../../components/element/NoDataPlaceholder";
import dayjs from "dayjs";
import { formatToTwoDecimal } from "../../../../utils/utils";
import { DATE_FORMAT } from "../../../../utils/constants";

const ViewFuelRoyaltyInvoiceTable = ({ invoiceData, isLoading, error }) => {

  if (error) {
    if (error.status === 404) {
      return <NoDataPlaceholder />;
    } else {
      return <ErrorPopup children={error.message}></ErrorPopup>;
    }
  }

  if (isLoading) {
    return <Loader />;
  }

  if (invoiceData && invoiceData.length === 0) {
    return <NoDataPlaceholder />;
  }

  return (
    <div className="view-invoice-table-parent-container">
      <div className="view-invoice-table-container">
        <table className="view-invoice-table">
          <thead>
            <tr>
              <th>No.</th>
              <th>ABO Name</th>
              <th>Submitted At</th>
              <th>Meter Id</th>
              <th>Start Reading (gallons)</th>
              <th>End Reading (gallons)</th>
              <th>Total Fuel (gallons)</th>
              <th>Fuel Wastage (gallons)</th>
              <th>Fuel Recirculation (gallons)</th>
              <th>Fuel Testing (gallons)</th>
              <th>Fuel Royalty Price (per gallon)</th>
              <th>VAT (10%)</th>
              <th>Total Fee</th>
            </tr>
          </thead>
          <tbody>
            {invoiceData?.map((item, index) => (
              <React.Fragment key={index}>
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item?.fboName}</td>
                  <td>
                    {dayjs(item?.submittedAt).utc().format(DATE_FORMAT)}
                  </td>
                  <td>{item?.meterId}</td>
                  <td>{item?.startReading}</td>
                  <td>{item?.endReading}</td>
                  <td>{item?.totalFuel}</td>
                  <td>{item?.fuelWastage}</td>
                  <td>{item?.fuelRecirculation}</td>
                  <td>{item?.fuelTesting}</td>
                  <td>{`BSD ${formatToTwoDecimal(item?.rate)}`}</td>
                  <td>{formatToTwoDecimal(item?.tax)}</td>
                  <td>{`BSD ${formatToTwoDecimal(item?.totalFee + item?.tax)}`}</td>
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ViewFuelRoyaltyInvoiceTable;
